import BioscopeLine from '@/assets/icons/bioscope_line.svg?component';
import FishGroupLine from '@/assets/icons/fish_group_line.svg?component';
import FishPenLine from '@/assets/icons/fish_pen_line.svg?component';
import { ActionIcon, type FishGroupActionKind } from '@/components/organisms/FishGroupForms';

import Glyph from '../Glyph/Glyph';

import styles from './SiteActionDialog.module.scss';

interface ActionDialogTitleProps {
    kind: FishGroupActionKind;
    title: string;
    groupName: string;
    penName: string | null;
    bioscopeIds: number[];
}

/** An action dialog's heading: the action, then the group it acts on, its pen and bioscope. */
export default function ActionDialogTitle(props: ActionDialogTitleProps) {
    const { kind, title, groupName, penName, bioscopeIds } = props;
    return (
        <span className={styles.heading}>
            <ActionIcon kind={kind} size="lg" />
            <span className={styles.headingText}>
                <span className={styles.title}>{title}</span>
                <span className={styles.meta}>
                    <span className={styles.metaItem}>
                        <Glyph icon={FishGroupLine} />
                        {groupName}
                    </span>
                    {penName && (
                        <span className={styles.metaItem}>
                            <Glyph icon={FishPenLine} />
                            {penName}
                        </span>
                    )}
                    {bioscopeIds.length > 0 && (
                        <span className={styles.metaItem}>
                            <Glyph icon={BioscopeLine} />
                            {bioscopeIds.join(', ')}
                        </span>
                    )}
                </span>
            </span>
        </span>
    );
}
